<template>
    <common-content-spacer class="company-private-profile" height="super-huge">
        <common-content-wrapper width="medium">
            <div class="company-private-profile__image">
                <img class="company-private-profile__image-cover" :src="coverImage" :alt="$t('alt.company_cover')" />
                <common-button
                    class="company-private-profile__image-button"
                    type="primary"
                    size="micro"
                    :label="coverButtonLabel"
                    @click="goToGalleryTab()"
                ></common-button>
            </div>
            <common-page-header v-if="company.name" :heading="company.name" :isCenter="true" size="large">
                <template #content>
                    <div v-if="company.subdomain" class="common-page-header__company_subdomain">
                        <common-icon class="url_icon" name="url" size="small"></common-icon>
                        <a :href="'https://' + hostURL" target="_blank">https://{{ hostURL }}</a>
                    </div>
                </template>
            </common-page-header>
            <common-company-avatar
                :company="company"
                :withBorder="true"
                :showOrginalImage="true"
                :hoverText="companyAvatarHoverText"
                size="medium"
                @avatar-click="openUploadPhotoModal"
            ></common-company-avatar>
            <upload-photo-modal
                v-if="isUploadPhotoModalOpen"
                :heading="$t('pages.company.my_company.buttons.upload_company_logo')"
                :uploadPhotoApi="uploadProfilePhotoApi"
                :previousPhoto="company.photoMain"
                @photo-uploaded="reloadCompanyAndCloseModal"
                @close="closeUploadPhotoModal"
            ></upload-photo-modal>
        </common-content-wrapper>
    </common-content-spacer>
</template>

<script>
    import UploadPhotoModal from 'components/modals/UploadPhotoModal'
    import CompanyAPI from 'api/CompanyAPI'

    export default {
        components: {
            UploadPhotoModal,
        },

        props: {
            company: { type: Object, required: true },
            isUser: { type: Boolean, default: false },
        },

        data: () => ({
            isUploadPhotoModalOpen: false,
        }),

        computed: {
            uploadProfilePhotoApi() {
                return ({ main, avatar }) =>
                    CompanyAPI.uploadMainPhoto({ id: this.company.id, main, avatar }).then(() => this.$auth.reloadUser())
            },
            coverImage() {
                return this.company.photoCover
                    ? this.company.photoCover
                    : require('../../../../assets/images/company-cover-placeholder.png')
            },
            hostURL() {
                return `${this.company.subdomain}.${window.location.host}`
            },

            coverButtonLabel() {
                return this.isUser ? undefined : this.$t('pages.company.my_company.buttons.change_cover_photo')
            },

            companyAvatarHoverText() {
                return this.isUser ? undefined : this.$t('common.microcopy.select')
            },
        },

        methods: {
            openUploadPhotoModal() {
                if (!this.isUser) {
                    this.isUploadPhotoModalOpen = true
                }
            },

            closeUploadPhotoModal() {
                this.isUploadPhotoModalOpen = false
            },

            reloadCompanyAndCloseModal() {
                this.emitEvent({ name: 'reload-company' })
                this.closeUploadPhotoModal()
            },
            goToGalleryTab() {
                return !this.isUser ? this.emitEvent({ name: 'go-to-gallery-tab' }) : undefined
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/company/profile/_company-private-profile.scss';
</style>
